export var ArticleStatusEnum;
(function (ArticleStatusEnum) {
    ArticleStatusEnum["DRAFT"] = "DRAFT";
    ArticleStatusEnum["PUBLISHED"] = "PUBLISHED";
    ArticleStatusEnum["AWAITING"] = "AWAITING";
})(ArticleStatusEnum || (ArticleStatusEnum = {}));
//# sourceMappingURL=article-status.enum.js.map